var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "100px",
    viewBox: "-16 -5 200 100",
    enableBackground: "new -16 -5 200 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B2F67",
    d: "M144.459,73.59c0,0-3.48,4.908-9.965,9.525c-6.482,4.617-11.617,5.895-11.617,5.895 s-4.979-1.514-11.227-5.895s-10.176-9.525-10.176-9.525s3.48-4.91,9.963-9.525c6.482-4.617,11.439-5.896,11.439-5.896 s5.158,1.516,11.406,5.896C140.529,68.445,144.459,73.59,144.459,73.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M134.49,69.572c-0.963-0.082-1.922,0.621-2.143,1.523c-0.201,0.934,0.385,1.77,1.344,1.85 c0.143,0.012,0.287-0.021,0.426-0.01c-0.488,2.059-2.172,4.779-3.764,4.645c-0.588-0.051-0.68-0.592-0.568-1.043l1.371-6 c0.301-1.246-0.521-2.352-1.811-2.467c-0.121-0.01-0.242-0.008-0.365,0l-0.502,2.135l-0.283,1.416l-1.258,5.365 c-0.219,0.859,0.176,2.51,2.025,2.668c2.859,0.246,5.863-3.264,6.854-7.498C136.229,70.459,135.428,69.65,134.49,69.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M123.109,61.559c-0.912-0.039-1.697,0.891-1.758,2.074c-0.059,1.184,0.633,1.996,1.541,2.035 c0.912,0.039,1.697-0.709,1.758-1.891C124.709,62.59,124.018,61.596,123.109,61.559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.77,69.451c0.959-0.072,1.908,0.643,2.121,1.551c0.189,0.934-0.408,1.762-1.369,1.832 c-0.141,0.01-0.285-0.025-0.424-0.016c0.463,2.066,2.111,4.807,3.707,4.689c0.586-0.043,0.684-0.58,0.58-1.035l-1.297-6.016 c-0.285-1.248,0.551-2.35,1.84-2.443c0.125-0.01,0.246-0.006,0.365,0.004l0.477,2.137l0.268,1.422l1.189,5.383 c0.209,0.859-0.207,2.506-2.061,2.641c-2.859,0.211-5.818-3.332-6.758-7.58C110.018,70.318,110.83,69.52,111.77,69.451"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M125.287,75.959c-0.203-0.104-0.484-0.221-0.91-0.1l0.006-2.439v-6.086 c-0.109-0.008-2.852-0.184-2.852,1.699v7.805c-0.004,1.219,0.965,2.18,2.053,2.18c0.951,0,1.34-0.254,1.844-0.887 C125.936,77.488,125.91,76.281,125.287,75.959"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.875,80.549c0,0-7.08,0.746-7.805,0.816c0,0.424,0.166,0.727,0.453,0.928 c0.318,0.223,0.689,0.342,1.373,0.342h11.957c0.686,0,1.055-0.119,1.373-0.342c0.291-0.201,0.453-0.504,0.453-0.928 C129.957,81.295,122.875,80.549,122.875,80.549"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M104.332,81.672c-0.09-0.076-0.178-0.154-0.266-0.232C104.154,81.518,104.242,81.596,104.332,81.672  M97.338,74.521c0.541,0.65,1.32,1.557,2.314,2.619c-0.996-1.064-1.771-1.971-2.313-2.619H97.338z M97.484,72.066L97.484,72.066 c0.537-0.67,1.283-1.561,2.232-2.59C98.768,70.506,98.023,71.395,97.484,72.066 M133.746,59.787 c-0.271-0.174-0.543-0.344-0.809-0.51C133.203,59.443,133.475,59.613,133.746,59.787 M112.127,59.178 c0.166-0.105,0.332-0.207,0.496-0.307C112.459,58.971,112.293,59.072,112.127,59.178 M112.623,58.871 c0.162-0.098,0.318-0.193,0.475-0.285C112.941,58.678,112.785,58.773,112.623,58.871 M113.098,58.586 c5.574-3.332,9.438-4.342,9.438-4.342s4.445,1.342,10.402,5.033c-5.957-3.691-10.402-5.035-10.402-5.035 S118.672,55.254,113.098,58.586"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 95.99,
    y: 53.533,
    width: 40.156,
    height: 29.527
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.096364e-006 -6.977993e-006)",
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 68,
    height: 50,
    xlinkHref: "99854A0E.jpg",
    transform: "matrix(0.5905 0 0 -0.5905 95.9902 83.0605)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B617",
    d: "M146.963,45.003v-0.011c0,0-11.508-15.176-29.809-28.103C98.85,3.967,83.823-0.508,83.823-0.508 s-14.6,3.773-33.594,17.397C31.236,30.515,21.037,44.992,21.037,44.992l0.003,0.011c0,0,11.508,15.179,29.81,28.104 c18.304,12.93,33.33,17.4,33.33,17.4s8.137-2.107,20.152-8.836c-4.932-4.322-7.879-8.252-7.879-8.252v-0.006 c0,0,4.238-6.102,12.127-11.84c7.889-5.742,13.957-7.334,13.957-7.334s4.852,1.469,11.209,5.551 C142.404,51.457,146.963,45.003,146.963,45.003"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M83.425,29.136l-9.815,11.786l-0.034,9.207l-4.535,0.314l0.105,2.791l1.604,0.523 c0,0,0.033,11.613,0,20.75c4.712,3.895,14.283,8.379,25.104,11.504c0.625-0.291,1.273-0.596,1.938-0.92 c0.018-0.008,0.037-0.018,0.055-0.025c0.016-0.01,0.035-0.018,0.055-0.027c1.98-0.967,4.135-2.08,6.432-3.367 c-4.932-4.322-7.879-8.252-7.879-8.252v-0.004c0,0,0,0,0.002-0.002c0.018-0.025,0.363-0.521,1.029-1.348 c0.539-0.672,1.283-1.561,2.232-2.59c2.041-2.225,5.02-5.105,8.863-7.902c7.627-5.551,13.549-7.223,13.936-7.328l0,0 c0.002-0.002,0.004-0.002,0.004-0.002c0.002,0,0.002,0,0.006,0h0.004c0.004-0.002,0.006-0.002,0.006-0.002 s4.854,1.467,11.211,5.545c0.037-0.033,0.076-0.068,0.111-0.102c0.029-0.031,0.061-0.063,0.09-0.09 c0.002-0.002,0.004-0.002,0.004-0.002c1.422-1.377,2.736-2.699,3.934-3.949c-3.67-5.166-8.662-11.066-15.225-17.791 c-7.77-7.96-32.939-30.969-39.008-32.224C83.652,14.175,83.425,29.136,83.425,29.136"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible",
    fill: "#C8942D"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 67.238,
    y: 4.234,
    width: 73.227,
    height: 83.266
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.773,29.705h-8.251c0,2.786-5.896,6.248-5.896,11.229H93.67C93.67,35.953,87.773,32.491,87.773,29.705"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "77.666,29.705 89.629,29.705 89.725,29.611 89.725,25.748 89.629,25.653 77.666,25.653  77.57,25.748 77.57,29.611  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M85.733,25.124c0-0.649-0.181-1.287-0.527-1.849l-0.407-0.662h-0.473v-2.006h2.633h7.799l-5.779-2.461 l5.713-2.462h-7.732h-2.633v-2.75l0.778-1.039c0,0,0.728-0.591-0.727-2.152H84.28l-0.665-4.148l-0.667,4.148h-0.033 c-1.45,1.562-0.726,2.152-0.726,2.152l0.791,1.055v9.663h-0.485l-0.406,0.662c-0.347,0.562-0.526,1.199-0.526,1.849v0.529h4.171 V25.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M98.371,49.852h-4.582v-8.073H81.707v8.073H80.73v-8.073h-7.225v8.073h-4.581 c-0.27,0-0.487,0.217-0.487,0.486v2.957c0,0.27,0.218,0.49,0.487,0.49h1.802v0.752l4.753,2.834l4.508-2.924l0.025-0.018 l0.024-0.01l0.032-0.016l0.028-0.012l0.031-0.008l0.03-0.01l0.027-0.004h0.04l0.025-0.002h0.004l0.024,0.002l0.045,0.002 l0.026,0.004l0.023,0.008l0.021,0.002c0.132,0.043,6.979,2.432,8.734,3.045l8.352-2.666v-0.98h0.889 c0.27,0,0.486-0.221,0.486-0.49v-2.957C98.857,50.068,98.641,49.852,98.371,49.852 M69.413,52.809v-1.98h2.307l-0.01,0.104v1.773 l0.01,0.104H69.413z M72.673,52.809l0.013-0.104v-1.773l-0.013-0.104h2.32l-0.013,0.104v1.773l0.013,0.104H72.673z M76.02,44.93 h3.502v4.922H76.02V44.93z M75.943,52.809l0.013-0.104v-1.773l-0.013-0.104h2.32l-0.012,0.104v1.773l0.012,0.104H75.943z  M79.217,52.809l0.011-0.104v-1.773l-0.011-0.104h2.319l-0.013,0.104v1.773l0.013,0.104H79.217z M90.471,44.93h2.338v4.922h-2.338 V44.93z M83.647,44.93h3.8v4.922h-3.8V44.93z M82.488,52.809l0.012-0.104v-1.773l-0.012-0.104h2.318l-0.012,0.104v1.773 l0.012,0.104H82.488z M85.76,52.809l0.012-0.104v-1.773l-0.012-0.104h2.318l-0.01,0.104v1.773l0.01,0.104H85.76z M89.033,52.809 l0.01-0.104v-1.773l-0.01-0.104h2.318l-0.014,0.104v1.773l0.014,0.104H89.033z M92.303,52.809l0.014-0.104v-1.773l-0.014-0.104 h2.32l-0.014,0.104v1.773l0.014,0.104H92.303z M97.883,52.809h-2.309l0.014-0.104v-1.773l-0.014-0.104h2.309V52.809z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "81.714,67.371 87.662,67.371 84.688,65.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "80.738,66.881 83.874,64.527 80.738,62.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "84.688,63.916 87.662,61.684 81.714,61.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "96.996,62.209 94.086,64.527 96.996,66.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "90.52,67.371 96.088,67.371 93.303,65.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "93.305,63.904 96.088,61.682 90.52,61.682  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "75.782,66.385 77.165,64.525 75.782,62.668  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M89.123,58.434l-0.16-0.027c-2.422-0.846-6.628-2.311-8.225-2.867v5.096l-0.006,0.074h16.75v-4.92 l-8.211,2.619L89.123,58.434z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "74.368,61.684 71.652,61.684 73.01,63.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "73.01,65.389 71.652,67.369 74.368,67.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "74.807,62.771 73.603,64.527 74.807,66.281  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "71.215,66.283 72.419,64.525 71.215,62.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "75.296,68.346 75.295,68.346 75.293,68.346 70.727,68.346 70.727,74.521 80.252,74.521  97.482,74.521 97.482,68.346 80.252,68.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "75.756,58.355 75.489,58.432 75.239,58.365 70.727,55.674 70.727,60.709 79.771,60.709  79.764,60.635 79.764,55.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "79.28,61.684 76.264,61.684 77.772,63.707  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "77.773,65.344 76.265,67.369 79.28,67.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "79.764,62.668 78.38,64.527 79.764,66.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "85.496,64.598 89.109,67.311 92.516,64.598 89.109,61.883  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViv);
export default __webpack_public_path__ + "static/media/viv.e5a6a19fad952e8fa8f27b0964ebc926.svg";
export { ForwardRef as ReactComponent };